export const hasMyaccount =
  (process.env.GATSBY_MYACCOUNT || null) === "1" ? true : false
